<template>
  <basicContainer>
    <processMonitorMain @rowClick="rowClick"></processMonitorMain>
    <processMonitorDetail :processInstanceId='processInstanceId' ref="processMonitorDetail"></processMonitorDetail>
  </basicContainer>
</template>

<script>

import processMonitorMain from './processMonitorMain'
import processMonitorDetail from './processMonitorDetail'
export default {
  data() {
    return {
      processInstanceId: ''
    }
  },

  components: { processMonitorMain, processMonitorDetail },

  methods: {
    // 主表点击事件
    rowClick(row) {
      this.processInstanceId = row.processInstanceId
      this.$nextTick(() => {
        this.$refs.processMonitorDetail.onLoad()
      })
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
